/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useEffect } from 'react'
import { formatLongNumber } from 'utils/number'
import { format } from 'date-fns'
import { HitCardProps } from './Types'
import { DEFAULT_URL_LINK, PlatformLink, DEFAULT_AVATAR_URL } from './Utils'
import HitDetailsModal from 'components/HitDetailsModal/HitDetailsModal'
import { shortenString } from 'utils/shortenString'
import { Box } from '@mui/material'
import { useInteractedWithHitMutation } from 'graphql/generated/graphql'
import { useNavigate, useParams } from 'react-router-dom'

import {
  SocialCard,
  CardHeader,
  PlatformBadge,
  CardImage,
  CardContent,
  CardFooter,
  SocialStats,
  ReplyButton,
  DateText,
  ProfileImage,
  PlayButton,
  HashTag,
  ContentText,
  VideoCard,
  VideoContainer,
  VideoOverlay,
  VideoHeader,
  VideoContent,
  VideoHashTag,
  VideoContentText,
  VideoFooter,
  CardWrapper,
  ReplyIcon,
} from './StyleHit'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import { Icons } from 'constants/icon'
import { ExternalLink } from 'lucide-react'
import {
  InstagramEmbed,
  FacebookEmbed,
  TikTokEmbed,
} from 'react-social-media-embed'
import { TikTok } from 'react-tiktok'

export default function HitCard({
  body,
  headerProps,
  data,
}: HitCardProps): JSX.Element {
  const navigate = useNavigate()
  const [isVideo, setIsVideo] = React.useState<boolean>(false)
  const hashtags = body.match(/#\w+/g) ?? []
  const bodyWithoutHashtags = body.replace(/#\w+/g, '').trim()
  const displayDate = format(headerProps?.date, 'd MMM y')
  const [openHitDetails, setOpenHitDetails] = React.useState(false)
  const [scriptTag, setScriptTag] = React.useState<HTMLScriptElement | null>(
    null
  )
  const [youtubeHits, setYoutubeHits] = React.useState<any[]>([])
  const [redditHits, setRedditHits] = React.useState<any[]>([])

  const [addInteraction] = useInteractedWithHitMutation()
  const [interacted, setInteracted] = React.useState<boolean>(
    headerProps.interactedWith
  )
  const params = useParams()

  const handleScriptTag = (): void => {
    const script = document.createElement('script')
    script.src = 'https://embed.reddit.com/widgets.js'
    script.async = true
    script.onload = function () {
      console.log('Reddit script loaded.')
    }
    document.body.appendChild(script)
    setScriptTag(script)
  }
  const handleOpenDetails = (): void => {
    if (headerProps.platform === 'Reddit') {
      handleScriptTag()
    }
    setOpenHitDetails(true)
  }
  const handleCloseDetails = (): void => {
    setOpenHitDetails(false)
    if (scriptTag && headerProps.platform === 'Reddit') {
      document.body.removeChild(scriptTag)
    }
  }

  // <HitCardStyle.HitCardWrapper sx={{ height: '100%' }}>
  //   <HitCardStyle.HitCardHeader>
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'space-between',
  //         alignItems: 'center',
  //         width: '100%',
  //       }}
  //     >
  //       <HitCardStyle.HitCardPlatform
  //         href={PlatformLink(
  //           headerProps?.hitItemId,
  //           headerProps?.platform,
  //           headerProps.postURL
  //         )}
  //         target="_blank"
  //         onClick={() => {
  //           if (!headerProps.interactedWith) {
  //             setInteracted(true)
  //             addInteraction({
  //               variables: {
  //                 campaignId: params.campaignId ?? '',
  //                 hitId: headerProps.hitItemId,
  //               },
  //             }).catch((e) => {
  //               console.log(e)
  //             })
  //           }
  //         }}
  //       >
  //         <Keyword
  //           platform={headerProps?.platform}
  //           text={headerProps?.platform}
  //           sideIcon={<HitCardStyle.LaunchIconStyle />}
  //         ></Keyword>
  //       </HitCardStyle.HitCardPlatform>
  //       {headerProps.tag && <ClassificationTag tagName={headerProps.tag} />}
  //     </div>
  //     <HitCardStyle.HitCardIconWrapper>
  //       {interacted && (
  //         <Tooltip title="You have interacted with this hit">
  //           <IconButton>
  //             <ButtonPrimary buttonTitle={<HitCardStyle.InfoIconStyle />} />
  //           </IconButton>
  //         </Tooltip>
  //       )}
  //     </HitCardStyle.HitCardIconWrapper>
  //   </HitCardStyle.HitCardHeader>
  //   <HitCardStyle.HitCardBody onClick={() => handleOpenDetails()}>
  //     {headerProps?.imageSource === DEFAULT_URL_LINK ? null : (
  //       <HitCardStyle.HitCardImage
  //         src={headerProps?.imageSource}
  //         alt="Hit Card Image"
  //       />
  //     )}
  //     <HitCardStyle.HitCardText>
  //       {shortenString(body, 300)}
  //     </HitCardStyle.HitCardText>
  //   </HitCardStyle.HitCardBody>
  //   <HitCardStyle.HitCardFooter>
  //     <HitCardStyle.HitCardUserDetails>
  //       <HitCardStyle.UserDetailsWrapper>
  //         <HitCardStyle.UserImage
  //           src={headerProps?.avatar ?? DEFAULT_AVATAR_URL}
  //           alt="Avatar"
  //         />
  //         <HitCardStyle.DataWrapper>
  //           <HitCardStyle.UserName>
  //             {shortenString(headerProps?.authorName, 20)}
  //           </HitCardStyle.UserName>
  //           <HitCardStyle.DatePosted>{displayDate}</HitCardStyle.DatePosted>
  //         </HitCardStyle.DataWrapper>
  //       </HitCardStyle.UserDetailsWrapper>
  //     </HitCardStyle.HitCardUserDetails>
  //     <HitCardStyle.HitCardInteractionsContainer>
  //       <HitCardStyle.HitCardInteraction>
  //         <HitCardStyle.FavoriteIconStyle />
  //         <HitCardStyle.InteractionCounter>
  //           {formatLongNumber(headerProps?.reactionCount)}
  //         </HitCardStyle.InteractionCounter>
  //       </HitCardStyle.HitCardInteraction>
  //       <HitCardStyle.HitCardInteraction>
  //         <HitCardStyle.ShareIconStyle />
  //         <HitCardStyle.InteractionCounter>
  //           {formatLongNumber(headerProps?.shareCount)}
  //         </HitCardStyle.InteractionCounter>
  //       </HitCardStyle.HitCardInteraction>
  //     </HitCardStyle.HitCardInteractionsContainer>
  //   </HitCardStyle.HitCardFooter>
  // </HitCardStyle.HitCardWrapper>

  useEffect(() => {
    const { postURL } = headerProps || {}
    if (postURL) {
      const isReel = postURL.includes('/reel/')
      const isVideo = postURL.includes('/video/') || isReel
      setIsVideo(isVideo)
    } else {
      setIsVideo(false)
    }
  }, [headerProps])

  React.useEffect(() => {
    if (data && data.length > 0) {
      const youtubeData = data.filter((item) => item.platforms[0] === 'Youtube')
      setYoutubeHits(youtubeData)
      const redditData = data.filter((item) => item.platforms[0] === 'Reddit')
      setRedditHits(redditData)
    }
  }, [data])

  return (
    <CardWrapper>
      {isVideo ? (
        <VideoCard
          sx={{
            border:
              headerProps.platform === 'TikTok' ||
              headerProps.platform === 'Instagram'
                ? headerProps?.yellowish
                  ? '5px solid #FEB820'
                  : headerProps.platform === 'TikTok'
                  ? '2px solid #d3d3d3'
                  : '0px'
                : '0px',
            boxShadow: headerProps?.yellowish
              ? '4px 8px 20px 0px #FEB82040'
              : '4px 8px 20px 0px #FFFFFF40',
          }}
        >
          <VideoContainer
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => handleOpenDetails()}
          >
            {headerProps.platform === 'TikTok' ? (
              <>
                {/* <TikTok url={headerProps.postURL} width={349} /> */}
                <TikTokEmbed url={headerProps?.postURL} width={349} />
              </>
            ) : headerProps.platform === 'Instagram' ? (
              <>
                <InstagramEmbed url={headerProps?.postURL} width={349} />
              </>
            ) : headerProps.platform === 'Facebook' ? (
              <>
                <FacebookEmbed url={headerProps?.postURL} width={349} />
              </>
            ) : (
              <>
                <video
                  src={
                    headerProps.platform === 'Youtube'
                      ? `https://www.youtube.com/embed/${headerProps.hitItemId}`
                      : headerProps?.imageSource || DEFAULT_URL_LINK
                  }
                  poster={
                    headerProps?.thumbnail ||
                    headerProps?.imageSource ||
                    DEFAULT_URL_LINK
                  }
                  controls={false}
                  autoPlay={true}
                  muted
                  loop
                  playsInline
                />
                <PlayButton>
                  <PlayArrowIcon sx={{ fontSize: 40 }} />
                </PlayButton>
              </>
            )}
          </VideoContainer>
          <VideoOverlay />
          <VideoHeader
            sx={{
              display:
                headerProps.platform === 'Instagram' ||
                headerProps.platform === 'TikTok' ||
                headerProps.platform === 'Facebook'
                  ? 'none'
                  : 'flex',
            }}
          >
            <PlatformBadge
              sx={{
                cursor: 'pointer',
              }}
              href={PlatformLink(
                headerProps?.hitItemId,
                headerProps?.platform,
                headerProps.postURL
              )}
              target="_blank"
              onClick={() => {
                if (!headerProps.interactedWith) {
                  setInteracted(true)
                  addInteraction({
                    variables: {
                      campaignId: params.campaignId ?? '',
                      hitId: headerProps.hitItemId,
                    },
                  }).catch((error) => {
                    console.error(error)
                  })
                }
              }}
            >
              {headerProps?.platform}
              <span className="platform-arrow">›</span>
            </PlatformBadge>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <DateText>{displayDate}</DateText>
              <ProfileImage
                src={headerProps?.avatar ?? DEFAULT_AVATAR_URL}
                alt="Profile"
                loading="lazy"
              />
            </Box>
          </VideoHeader>
          <VideoContent>
            <Box
              sx={{
                display: 'flex',
                gap: '10px',
                flexWrap: 'wrap',
                marginBottom: '10px',
              }}
            >
              {hashtags.slice(0, 1).map((hash) => (
                <VideoHashTag key={hash}>{hash}</VideoHashTag>
              ))}
              {hashtags.length > 1 && <HashTag>+{hashtags.length - 1}</HashTag>}
            </Box>
            <VideoContentText>
              {shortenString(bodyWithoutHashtags, 100)}
            </VideoContentText>
          </VideoContent>
          <VideoFooter>
            <SocialStats>
              <Box className="stat">
                <img src={Icons.heart} alt="heart" width={27} height={27} />
                {formatLongNumber(headerProps?.reactionCount)}
              </Box>
              <Box className="stat">
                <img src={Icons.retweet} alt="retweet" width={27} height={27} />
                {formatLongNumber(headerProps?.shareCount)}
              </Box>
              <Box
                className="stat"
                onClick={() => window.open(headerProps.postURL, '_blank')}
                sx={{ cursor: 'pointer', '&:hover': { opacity: 0.7 } }}
                title="View original post"
              >
                <ExternalLink size={24} />
              </Box>
            </SocialStats>
            <ReplyButton
              variant="contained"
              className={headerProps.interactedWith ? 'replied' : 'no-reply'}
              onClick={() => {
                if (headerProps.interactedWith) return
                if (
                  ['Instagram', 'Facebook', 'TikTok'].includes(
                    headerProps.platform
                  )
                ) {
                  if (!headerProps.interactedWith) {
                    setInteracted(true)
                    addInteraction({
                      variables: {
                        campaignId: params.campaignId ?? '',
                        hitId: headerProps.hitItemId,
                      },
                    }).catch((e) => {
                      console.log(e)
                    })
                  }
                  window.open(headerProps.postURL, '_blank')
                } else {
                  navigate('/postdetails', {
                    state: {
                      headerProps,
                      body,
                      youtubeHits:
                        headerProps.platform === 'Youtube' ? youtubeHits : [],
                      redditHits:
                        headerProps.platform === 'Reddit' ? redditHits : [],
                    },
                  })
                }
              }}
            >
              {headerProps.interactedWith ? (
                <>
                  <ReplyIcon src={Icons.gCheck} alt="Replied" />
                  REPLIED
                </>
              ) : (
                <>
                  REPLY
                  <ReplyIcon src={Icons.wRightArrow} alt="Reply" />
                </>
              )}
            </ReplyButton>
          </VideoFooter>
        </VideoCard>
      ) : (
        <SocialCard
          sx={{
            border:
              headerProps.platform === 'TikTok' ||
              headerProps.platform === 'Instagram'
                ? headerProps?.yellowish
                  ? '5px solid #FEB820'
                  : headerProps.platform === 'TikTok'
                  ? '2px solid #d3d3d3'
                  : '0px'
                : '0px',
            boxShadow: headerProps?.yellowish
              ? '4px 8px 20px 0pxrgba(133, 125, 107, 0.25)'
              : '4px 8px 20px 0px #FFFFFF40',
          }}
        >
          <CardHeader
            sx={{
              display:
                headerProps.platform === 'Instagram' ||
                headerProps.platform === 'Facebook'
                  ? 'none'
                  : 'flex',
            }}
          >
            <PlatformBadge
              sx={{
                cursor: 'pointer',
              }}
              href={PlatformLink(
                headerProps?.hitItemId,
                headerProps?.platform,
                headerProps.postURL
              )}
              target="_blank"
              onClick={() => {
                if (!headerProps.interactedWith) {
                  setInteracted(true)
                  addInteraction({
                    variables: {
                      campaignId: params.campaignId ?? '',
                      hitId: headerProps.hitItemId,
                    },
                  }).catch((e) => {
                    console.log(e)
                  })
                }
              }}
            >
              {headerProps?.platform}
              <span className="platform-arrow">›</span>
            </PlatformBadge>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <DateText>{displayDate}</DateText>
              <ProfileImage
                src={headerProps?.avatar ?? DEFAULT_AVATAR_URL}
                alt="Profile"
                loading="lazy"
              />
            </Box>
          </CardHeader>
          {headerProps.platform === 'Instagram' ? (
            <>
              <InstagramEmbed url={headerProps.postURL} width={349} />
            </>
          ) : headerProps.platform === 'Facebook' ? (
            <>
              <FacebookEmbed url={headerProps.postURL} width={349} />
            </>
          ) : headerProps.platform === 'TikTok' ? (
            <>
              <TikTokEmbed url={headerProps.postURL} width={349} />
            </>
          ) : (
            <>
              <CardImage
                onClick={() => handleOpenDetails()}
                sx={{
                  cursor: 'pointer',
                  backgroundImage: `url(${
                    headerProps?.thumbnail ||
                    headerProps?.imageSource ||
                    DEFAULT_URL_LINK
                  })`,
                }}
              />
            </>
          )}
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                gap: '10px',
                flexWrap: 'wrap',
                marginBottom: '10px',
              }}
            >
              {hashtags.slice(0, 1).map((hash) => (
                <HashTag key={hash}>{hash}</HashTag>
              ))}
              {hashtags.length > 1 && <HashTag>+{hashtags.length - 1}</HashTag>}
            </Box>
            <ContentText>{shortenString(bodyWithoutHashtags, 100)}</ContentText>
          </CardContent>
          <CardFooter>
            <SocialStats>
              <Box className="stat">
                <img src={Icons.heart} alt="heart" width={27} height={27} />
                {formatLongNumber(headerProps?.reactionCount)}
              </Box>
              <Box className="stat">
                <img src={Icons.retweet} alt="retweet" width={27} height={27} />
                {formatLongNumber(headerProps?.shareCount)}
              </Box>
              <Box
                className="stat"
                onClick={() => window.open(headerProps.postURL, '_blank')}
                sx={{ cursor: 'pointer', '&:hover': { opacity: 0.7 } }}
                title="View original post"
              >
                <ExternalLink size={24} />
              </Box>
            </SocialStats>
            <ReplyButton
              variant="contained"
              className={headerProps.interactedWith ? 'replied' : 'no-reply'}
              onClick={() => {
                if (headerProps.interactedWith) return
                if (
                  ['Instagram', 'Facebook', 'TikTok'].includes(
                    headerProps.platform
                  )
                ) {
                  if (!headerProps.interactedWith) {
                    setInteracted(true)
                    addInteraction({
                      variables: {
                        campaignId: params.campaignId ?? '',
                        hitId: headerProps.hitItemId,
                      },
                    }).catch((e) => {
                      console.log(e)
                    })
                  }
                  window.open(headerProps.postURL, '_blank')
                } else {
                  navigate('/postdetails', {
                    state: {
                      headerProps,
                      body,
                      youtubeHits:
                        headerProps.platform === 'Youtube' ? youtubeHits : [],
                      redditHits:
                        headerProps.platform === 'Reddit' ? redditHits : [],
                    },
                  })
                }
              }}
            >
              {headerProps.interactedWith ? (
                <>
                  <ReplyIcon src={Icons.gCheck} alt="Replied" />
                  REPLIED
                </>
              ) : (
                <>
                  REPLY
                  <ReplyIcon src={Icons.wRightArrow} alt="Reply" />
                </>
              )}
            </ReplyButton>
          </CardFooter>
        </SocialCard>
      )}
      <HitDetailsModal
        body={body}
        headerProps={headerProps}
        openModal={openHitDetails}
        closeModal={handleCloseDetails}
      />
    </CardWrapper>
  )
}
